import React from 'react';

import { ShowBearingsIcon, ShowTrussRunsIcon } from '@paragon/material';

import { isLayoutViewActive, shouldShowBearingEnvelopeDimensions } from '../../../store/selectors/layoutModeSelectors';
import {
  toggleBearingDimensionVisibilityInLayout,
  toggleRunDimensionVisibilityInLayout,
} from '../../../store/slices/visualOptionsSlice';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { ToolbarIconButton } from '../top/ToolbarIconButton';

export function LayoutAutomaticDimensioningButtons() {
  const dispatch = useAppDispatch();

  const layoutViewActive = useAppSelector(isLayoutViewActive);

  const showRunDimensions = useAppSelector((state) => state.visualOptions.showRunDimensionsInLayout);
  const { setting: showBearingDimensions, overridden: bearingDimensionsDisabled } = useAppSelector(
    shouldShowBearingEnvelopeDimensions,
  );

  if (!layoutViewActive) return null;

  return (
    <>
      <ToolbarIconButton
        clickableDuringPicking
        title="Dimension Truss Runs"
        icon={<ShowTrussRunsIcon />}
        toggleValue={showRunDimensions}
        onClick={() => {
          dispatch(toggleRunDimensionVisibilityInLayout());
        }}
      />

      <ToolbarIconButton
        clickableDuringPicking
        title="Dimension Walls and Beams"
        icon={<ShowBearingsIcon />}
        disabled={bearingDimensionsDisabled}
        toggleValue={showBearingDimensions}
        onClick={() => {
          dispatch(toggleBearingDimensionVisibilityInLayout());
        }}
      />
    </>
  );
}
